import React from 'react';

// MUI
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

// Types
import { TimeMode } from '../../types/TimeMode';
import { TimeModeType } from '../../constants/Constants';

interface TimeModeToggleProps {
  value?: TimeMode;
  onChange: (timeMode: TimeMode) => void;
  label?: string;
  className?: string;
  // Extra styles merged into the wrapper (e.g. spacing when placed in a toolbar).
  sx?: any;
}

const TimeModeToggle = ({ value, onChange, label = 'Time :', className, sx }: TimeModeToggleProps) => {
  // ToggleButtonGroup reports null when the active button is clicked again — keep the current mode.
  const handleChange = (_event: React.MouseEvent<HTMLElement>, timeMode: TimeMode | null) => {
    if (timeMode) {
      onChange(timeMode);
    }
  };

  return (
    <Box className={className} sx={{ display: 'inline-flex', alignItems: 'center', ...sx }}>
      {label && <span style={{ paddingRight: 5, fontSize: 13, color: '#6B7280' }}>{label}</span>}
      <ToggleButtonGroup size='small' value={value} exclusive onChange={handleChange} aria-label='Time mode selection'>
        <ToggleButton value={TimeModeType.Local} aria-label='Local' sx={{ fontSize: 'xx-small' }}>
          Local
        </ToggleButton>
        <ToggleButton value={TimeModeType.Utc} aria-label='UTC' sx={{ fontSize: 'xx-small' }}>
          UTC
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default TimeModeToggle;
